    <div *ngFor="let w of widgets" axf-widget-renderer [widget]="w" mode="view" [parent]="this">
    </div>
    <div *ngIf="isLoading && (!widgets || !widgets.length)" class="skeleton" >
    </div>